<template>
  <grid-panel
      :column-defs="columnDefs"
      height="sm"
      :url="() => this.$api[apiModel].relationship('documents', model.id)"
      :auto-size="true"
      :showSearch="false"
      rowSelection="single"
      :gridOptions="gridOptions"
      @download="download"
      ref="documentsGrid"
      @update:gridApi="(gridApi) => this.gridApi = gridApi"
  >
    <vs-dropdown-item>
      <span
          class="flex items-center"
          @click="makeActive"
      >
        <feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" class="mr-2" />
        <span>Make Active</span>
      </span>
    </vs-dropdown-item>
  </grid-panel>
</template>

<script>
import GridPanel from "@/views/components/ag-grid/GridPanel";
import GridActionsMenu from "@/views/components/extra-components/GridActionsMenu";
import CellRendererDate from "@/views/components/ag-grid/cell-renderer/CellRendererDate";
import CellRendererVerified from "@/views/components/ag-grid/cell-renderer/CellRendererVerified";
import CellRendererDownload from "@/views/components/ag-grid/cell-renderer/CellRendererDownload";
import FileDownloadMixin from "@/components/mixins/FileDownloadMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import {dateFilterParams} from '../../components/ag-grid/filter-params/DateComparator';
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "DocumentGrid",
  props: {
    model: {
      type: Object,
      required: true,
    },
    apiModel: {
      type: String,
      required: true
    },
  },
  components: {
    GridPanel,
    GridActionsMenu,
    CellRendererDate,
    CellRendererVerified,
    CellRendererDownload,
  },
  mixins: [ FileDownloadMixin, NotificationMixin, IprProductCompanyTypeMixin ],
  data() {
    return {
      gridApi: null,
      columnDefs: [
        {
          headerName: 'Version',
          field: 'Version',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          maxWidth: 150,
        },
        {
          headerName: 'Filename',
          field: 'FriendlyName',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Modified Date',
          field: 'LastModifiedDateTime',
          filter: 'agTextColumnFilter',
          maxWidth: 160,
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
        {
          headerName: 'Active',
          field: 'IsActiveDocument',
          filter: 'agTextColumnFilter',
          maxWidth: 120,
          cellRenderer: "CellRendererVerified",
        },
        {
          headerName: 'Download',
          field: 'Document_UID',
          filter: false,
          maxWidth: 110,
          cellRenderer: "CellRendererDownload",
        },
      ],
      gridOptions: {},
    }
  },
  methods: {
    async makeActive() {
      const selectedItems = this.gridApi.getSelectedNodes();

      if (selectedItems.length === 0) {
        this.notifyError('Please select a document from the grid');
        return;
      }

      if (selectedItems.length > 1) {
        this.notifyError('Please select only one document from the grid');
        return;
      }

      const document = selectedItems[0];

      try {
        const params = { Document_ID: document.data.id };
        await this.$api[this.apiModel].setActive(this.model.id, params);
        this.$refs['documentsGrid'].list();
        this.notifySuccess('Active document updated');
      } catch (e) {
        this.notifyError('An error occurred');
        console.error(e)
      }

    },
  },
};
</script>

<style scoped>

</style>
